// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import MobileSvg from '@rsuite/icon-font/lib/device/Mobile';
var Mobile = createSvgIcon({
  as: MobileSvg,
  ariaLabel: 'mobile',
  category: 'device',
  displayName: 'Mobile'
});
export default Mobile;